import { render, staticRenderFns } from "./proxyCreateLeave.vue?vue&type=template&id=99352658&scoped=true&"
import script from "./proxyCreateLeave.vue?vue&type=script&lang=js&"
export * from "./proxyCreateLeave.vue?vue&type=script&lang=js&"
import style0 from "./proxyCreateLeave.vue?vue&type=style&index=0&id=99352658&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99352658",
  null
  
)

export default component.exports